import type { WebFilterWriteRequest } from '@/api/generated/schemas';
import { WebFilterPlacementKind, WebFilterPlacementSection } from '@/api/generated/schemas';
import type { PlacementOrderEditorState } from '../internal/placementOrderModel';
import { toPlacementOrderWriteLite } from '../internal/placementOrderModel';
import type { WebFilterFormValues } from './webFilterFormSchema';

function emptyToNull(value: string): string | null {
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/**
 * Mapuje formulář → API. Vypnutá sekce vynuluje isEnabled u svých kindů (nastavení zůstane v datech).
 */
export function toWebFilterRequestBody(
  values: WebFilterFormValues,
  placementOrder?: PlacementOrderEditorState
): WebFilterWriteRequest {
  const placementOrderPayload =
    placementOrder && placementOrder.dirtyKinds.length > 0
      ? toPlacementOrderWriteLite(placementOrder)
      : undefined;

  return {
    name: values.name.trim(),
    webProjectId: values.webProjectId,
    iconFileId: values.iconFileId,
    placements: values.placements.map((p) => {
      let isEnabled = p.isEnabled;
      if (p.section === WebFilterPlacementSection.MainMenu && !values.sectionMenuEnabled) {
        isEnabled = false;
      }
      if (p.section === WebFilterPlacementSection.SearchFilter && !values.sectionSearchEnabled) {
        isEnabled = false;
      }
      if (p.section === WebFilterPlacementSection.HomePage && !values.sectionHpEnabled) {
        isEnabled = false;
      }

      const supportsPhoto =
        p.kind === WebFilterPlacementKind.MenuBanner ||
        p.kind === WebFilterPlacementKind.HomeFindTour;

      return {
        id: p.id,
        section: p.section,
        kind: p.kind,
        isEnabled,
        labelText: emptyToNull(p.labelText),
        showPriceFrom:
          p.kind === WebFilterPlacementKind.MenuBanner ||
          p.kind === WebFilterPlacementKind.MenuTile ||
          p.kind === WebFilterPlacementKind.HomeFindTour
            ? p.showPriceFrom
            : false,
        description: emptyToNull(p.description),
        photoFileId: supportsPhoto ? p.photoFileId : null,
        payload: Object.keys(p.payload).length > 0 ? p.payload : null,
      };
    }),
    placementOrder: placementOrderPayload,
    criteria: values.criteria.map((item) => ({
      kind: item.kind,
      values: item.values,
    })),
  } satisfies WebFilterWriteRequest;
}
